module.exports = __webpack_public_path__ + "static/media/storepreviewStoreThree.31981922.svg";